import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchGrupoPlanes } from '../../actions/planesActions';
import { setTiposGrupoPlanes, resetValueChecked, setTiposPublicacion } from '../../actions/tiposPublicacionActions';
import ReactPaginate from 'react-paginate';
import GoBackArrow from '../General/GoBackArrow';
import { withNavigation } from '../General/withNavigation';

// Wrapper para usar hooks en class component
function BusquedaGrupoPlanesWrapper(props) {
    const navigate = useNavigate();
    return <BusquedaGrupoPlanes {...props} navigate={navigate} />;
}


class BusquedaGrupoPlanes extends Component {
    constructor(props) {
        super(props);
        const selected = Array.isArray(this.props.tiposGruposPlanes) ? [...this.props.tiposGruposPlanes] : [];

        this.state = {
            Descripcion: "",
            page: 1,
            CantidadTotal: 0,
            estadoGrupoPlanes: selected
        };
    }


    componentDidMount() {
        let request = { params: { page: 1, pageSize: 10 } };
        this.props.fetchGrupoPlanes(request);
    }

    isChecked = (item) => {
        return this.state.estadoGrupoPlanes.some(x => x.idGrupoPlan === item.idGrupoPlan);
    }

    changeCheck = (item) => {
        let arrayGrupo = [...this.state.estadoGrupoPlanes];
        const exists = arrayGrupo.some(x => x.idGrupoPlan === item.idGrupoPlan);

        if (exists) {
            arrayGrupo = arrayGrupo.filter(x => x.idGrupoPlan !== item.idGrupoPlan);
        } else {
            arrayGrupo.push(item);
        }

        this.setState({ estadoGrupoPlanes: arrayGrupo });
    }

    agregarGrupoPlanes = (e) => {
        e.preventDefault();
        this.props.setTiposGrupoPlanes(this.state.estadoGrupoPlanes);
        const { editando, tiposPublicacion } = this.props;
        if (editando) {
            this.props.navigate(`/Tipo/Publicaciones/Editar/${tiposPublicacion}`);
        } else {
            this.props.navigate(`/Tipo/Publicaciones/Nuevo`);
        }
    }


    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        this.setState({ page: selectedPage }, () => {
            this.requestChange();
        });
    };

    myChangeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value, page: 1 }, () => {
            this.requestChange();
        });
    }


    requestChange = () => {
        let request = { params: { page: this.state.page, pageSize: 10, Descripcion: this.state.Descripcion } };
        this.props.fetchGrupoPlanes(request);
    }

    goBack = (e) => {
        e.preventDefault()
        window.history.go(-1)
    }

    render() {
        const { grupoPlanes, paginacion } = this.props;
        const totalItems = paginacion ? (paginacion.cantidadTotal || paginacion.total || 0) : 0;
        const itemsPerPage = paginacion ? (paginacion.cantidadPagina || paginacion.pageSize || 10) : 10;
        const pageCountVal = paginacion ? (paginacion.cantidadPaginas || paginacion.totalPages || Math.ceil(totalItems / itemsPerPage)) : 0;

        return (
            <div className="container card">
                <div className="row justify-content-between align-items-center card-body p-4">

                    <div className="card-body p-b-0 d-flex align-items-center">
                        <GoBackArrow />
                        <h4 className="card-title ml-2">Grupo de planes</h4>
                    </div>

                    <div className="row form-material pl-3 pt-2 mb-3">
                        <div className="col-12 col-md-4 col-12 col-md-1">
                            <label className="label-oscura">Descripcion</label>
                            <input
                                onChange={this.myChangeHandler}
                                className="form-control"
                                name="Descripcion"
                                type="text"
                                placeholder="Buscar..."
                            />
                        </div>
                    </div>


                    <form className="col-12 form-horizontal form-material p-10">

                        {grupoPlanes &&
                            grupoPlanes.map((item, index) => (
                                <div className="list-group" key={index}>
                                    <a>
                                        <div className="list-group-item hover-background-color">
                                            <div className="row justify-content-between align-items-center">
                                                <div className="col-2 col-md-1">
                                                    <h6 className="box-title font-weight-bold text-center">{item.idGrupoPlan}</h6>
                                                </div>

                                                <div className="col-6 col-md-6 text-break">
                                                    <small className="font-14 applyFont">{item.descripcion}</small>
                                                </div>

                                                <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
                                                    <small className="font-14 applyFont">{item.comision}</small>
                                                    <i className="fas fa-percent mx-1" />
                                                </div>

                                                <div className="col-2 col-md-2 d-flex justify-content-end align-items-center">
                                                    <div className="form-check form-switch custom-switch">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={"switch" + item.idGrupoPlan}
                                                            checked={this.isChecked(item)}
                                                            onChange={() => this.changeCheck(item)}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))
                        }

                        <div className="d-flex">
                            {paginacion && totalItems > 0 && (
                                <ReactPaginate
                                    previousLabel={"Anterior"}
                                    nextLabel={"Siguiente"}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={pageCountVal}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={this.state.page - 1}
                                />
                            )}
                        </div>

                        <div className="row align-items-center justify-content-center mb-3 text-center">
                            <button
                                onClick={this.agregarGrupoPlanes}
                                className="btn btn-sm btn-green waves-light col-auto mx-2"
                            >
                                Seleccionar
                            </button>
                            <div className="col-auto d-inline-flex">
                                <button onClick={(e) => this.goBack(e)} className="btn btn-sm background-rojo-megatone waves-effect waves-light">
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    seller: state.general.idSeller,
    editando: state.general.editando,
    paginacion: state.planes.grupoPlanes,
    grupoPlanes: state.planes.grupoPlanes.elementos,
    tiposGruposPlanes: state.tiposPublicacion.tiposGruposPlanes,
    tiposPublicacion: state.tiposPublicacion.tiposPublicacion.codigo
});


export default withNavigation(connect(mapStateToProps, {
    fetchGrupoPlanes,
    setTiposGrupoPlanes,
    resetValueChecked,
    setTiposPublicacion,
})(BusquedaGrupoPlanesWrapper));
